function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.61548 17.5C8.15523 17.5 7.77094 17.3458 7.4626 17.0375C7.15427 16.7292 7.0001 16.3449 7.0001 15.8846V5.11537C7.0001 4.65512 7.15427 4.27083 7.4626 3.9625C7.77094 3.65417 8.15523 3.5 8.61548 3.5H16.3847C16.845 3.5 17.2293 3.65417 17.5376 3.9625C17.8459 4.27083 18.0001 4.65512 18.0001 5.11537V15.8846C18.0001 16.3449 17.8459 16.7292 17.5376 17.0375C17.2293 17.3458 16.845 17.5 16.3847 17.5H8.61548ZM8.61548 16.5H16.3847C16.5386 16.5 16.6796 16.4359 16.8078 16.3077C16.936 16.1795 17.0001 16.0385 17.0001 15.8846V5.11537C17.0001 4.96154 16.936 4.82052 16.8078 4.6923C16.6796 4.5641 16.5386 4.5 16.3847 4.5H8.61548C8.46165 4.5 8.32062 4.5641 8.1924 4.6923C8.0642 4.82052 8.0001 4.96154 8.0001 5.11537V15.8846C8.0001 16.0385 8.0642 16.1795 8.1924 16.3077C8.32062 16.4359 8.46165 16.5 8.61548 16.5ZM5.61538 20.5C5.15513 20.5 4.77083 20.3458 4.4625 20.0375C4.15417 19.7292 4 19.3449 4 18.8846V7.11537H5V18.8846C5 19.0385 5.0641 19.1795 5.1923 19.3077C5.3205 19.4359 5.46153 19.5 5.61538 19.5H14.3846V20.5H5.61538Z",
  fill: "var(--n-color-text-dark)"
});

function SvgIconCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.eea2926be75da8b690657ec7ef571c23.svg";
export { ForwardRef as ReactComponent };